<template>
   <div class="container-fluid">
      <div class="card">
         <div class="card-body">

            <div class="form-check form-switch">
               <input
                  class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                  type="checkbox" id="flexSwitchCheckChecked" @click="ChangeSettings('enable_block_unsafe_site')"
                  :checked="settings['enable_block_unsafe_site']">
               <label class="form-check-label label-padding-bottom">&nbsp;&nbsp;&nbsp;<b>Block
                     Unsafe and Dangerous
                     Websites </b></label>
               <p>&nbsp;&nbsp;&nbsp;If enabled, automatically blocks dangerous websites.</p>
            </div>

            <br>

            <div class="row">
               <div class="col-10 mb-3">
                  <div class="card border">
                     <h5 class="card-header">Data Loss Protection</h5>
                     <div class="card-body">

                        <div class="form-check form-switch">
                           <input
                              class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                              type="checkbox" id="flexSwitchCheckChecked" @click="ChangeSettings('enable_block_dlp')"
                              :checked="settings['enable_block_dlp']">
                           <label class="form-check-label label-padding-bottom">&nbsp;&nbsp;&nbsp;<b>Data
                                 Loss Prevention (DLP)
                              </b></label>
                           <p>&nbsp;&nbsp;&nbsp;If enabled, it blocks all uploads. It adds Data Loss Prevention (DLP) to
                              ensure all
                              employees do not send any confidential information outside the corporate network.</p>
                        </div>

                        <br>

                        <div class="form-check form-switch">
                           <input
                              class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                              type="checkbox" id="flexSwitchCheckChecked"
                              @click="ChangeSettings('disable_file_sharing')"
                              :checked="settings['disable_file_sharing']">
                           <label class="form-check-label label-padding-bottom">&nbsp;&nbsp;&nbsp;<b>Disable File
                                 Sharing
                              </b></label>
                           <p>&nbsp;&nbsp;&nbsp;If enabled, disables file sharing.</p>
                        </div>

                        <br>

                        <div class="form-check form-switch">
                           <input
                              class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                              type="checkbox" id="flexSwitchCheckChecked"
                              @click="ChangeSettings('block_upload_all_websites')"
                              :checked="settings['block_upload_all_websites']">
                           <label class="form-check-label label-padding-bottom">&nbsp;&nbsp;&nbsp;<b>Block
                                 upload to all
                                 websites</b></label>
                           <p>&nbsp;&nbsp;&nbsp;If enabled, blocks all upload.</p>
                        </div>

                        <br>

                        <label class="form-check-label label-padding-bottom">&nbsp;&nbsp;&nbsp;<b>Common Cloud
                              Storage</b></label>

                        <div class="row">
                           <div class="col-8">
                              <table class="table table-responsive-sm table-striped">
                                 <thead class="table-light">
                                    <tr>
                                       <th scope="col"> Website</th>
                                       <th scope="col"> Allow</th>
                                    </tr>
                                 </thead>
                                 <tbody>
                                    <tr v-for="(storage, index) in common_cloud_storage" :key="index">
                                       <td style="vertical-align: middle;"> {{ storage.website }}</td>

                                       <td>
                                          <div class="form-check form-switch">
                                             <input
                                                class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                                                type="checkbox" id="flexSwitchCheckChecked"
                                                @click="AddOrRemoveStorageFromAccount(index)"
                                                :checked="common_cloud_storage[index].ww_id.Valid == true && common_cloud_storage[index].ww_id.Int64 > 0 && common_cloud_storage[index].allow_upload.Valid && common_cloud_storage[index].allow_upload.Bool">
                                          </div>
                                       </td>
                                    </tr>
                                 </tbody>
                              </table>

                           </div>
                           <div class="col"></div>
                        </div>


                     </div>
                  </div>
               </div>

               <div class="col-4"></div>
            </div>

            <br>

            <div class="form-check form-switch">
               <input
                  class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                  type="checkbox" id="flexSwitchCheckChecked" @click="ChangeSettings('enable_block_http')"
                  :checked="settings['enable_block_http']">
               <label class="form-check-label label-padding-bottom">&nbsp;&nbsp;&nbsp;<b>Block
                     HTTP
                     Websites</b></label>
               <p>&nbsp;&nbsp;&nbsp;If enabled, only HTTPS websites are allowed.</p>
            </div>

            <br>

            <div class="form-check form-switch">
               <input
                  class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                  type="checkbox" id="flexSwitchCheckChecked" @click="ChangeSettings('disable_logging')"
                  :checked="settings['disable_logging']">
               <label class="form-check-label label-padding-bottom">&nbsp;&nbsp;&nbsp;<b>Disable
                     Logging</b></label>
               <p>&nbsp;&nbsp;&nbsp;If enabled, only blocked pages or password pages are logged, but all other pages are
                  not logged for privacy
                  reasons</p>
            </div>

            <br>

            <div class="form-check form-switch">
               <input
                  class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                  type="checkbox" id="flexSwitchCheckChecked" @click="ChangeSettings('enable_safe_search')"
                  :checked="settings['enable_safe_search']">
               <label class="form-check-label label-padding-bottom">&nbsp;&nbsp;&nbsp;<b>Enforce Safe
                     Search</b></label>
               <p>&nbsp;&nbsp;&nbsp;If enabled, enforce safe search on Google, Yahoo/Altavista, DuckDuckGo and Bing.</p>
            </div>

            <br>

            <div>
               <div class="form-check form-switch">
                  <input
                     class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                     type="checkbox" id="flexSwitchCheckChecked" @click="ChangeSettings('enable_email_alerts')"
                     :checked="settings['enable_email_alerts']">
                  <label class="form-check-label label-padding-bottom">&nbsp;&nbsp;&nbsp;<b>Email Alerts
                        Protection</b></label>
                  <p>&nbsp;&nbsp;&nbsp;If enabled, send email alerts for unsafe URLs.</p>
               </div>
               <div v-if="settings['enable_email_alerts']" class="inputbox-padding">
                  <div class="input-group mb-3">
                     <input v-model="settings['alert_email']" type="text"
                        class="form-control form-control-max-width rounded-start-pill " placeholder="Enter Email...">
                     <!-- rounded-pill -->
                     <button @click="ChangeSettings('alert_email')" type="button"
                        class="btn btn-outline-secondary rounded-end-pill">Save</button>
                     <!-- rounded-pill -->
                  </div>
               </div>
            </div>

            <br>

            <div class="form-check form-switch">
               <input
                  class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                  type="checkbox" id="flexSwitchCheckChecked" @click="ChangeSettings('enable_phishing_protection')"
                  :checked="settings['enable_phishing_protection']">
               <label class="form-check-label label-padding-bottom">&nbsp;&nbsp;&nbsp;<b>Phishing
                     Protection</b></label>
               <p>&nbsp;&nbsp;&nbsp;If enabled, only allowed allowlisted websites for login.</p>
            </div>

            <br>

            <div class="form-check form-switch">
               <input
                  class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                  type="checkbox" id="flexSwitchCheckChecked" @click="ChangeSettings('block_download')"
                  :checked="settings['block_download']">
               <label class="form-check-label label-padding-bottom">&nbsp;&nbsp;&nbsp;<b>Block
                     Downloads</b></label>
               <p>&nbsp;&nbsp;&nbsp;If enabled, block download of dangerous files (e.g. .bat, .exe)</p>
            </div>

            <br>

            <div class="form-check form-switch">
               <input
                  class="form-check-input form-control form-custom-check-input form-custom-check-size border-success hand-cursor"
                  type="checkbox" id="flexSwitchCheckChecked" @click="ChangeSettings('block_all_websites')"
                  :checked="settings['block_all_websites']">
               <label class="form-check-label label-padding-bottom">&nbsp;&nbsp;&nbsp;<b>Block
                     All
                     Websites</b></label>
               <p>&nbsp;&nbsp;&nbsp;If enabled, block all websites except allowlisted websites.</p>
            </div>

            <br>

            <div class="col-6 mb-3">
               <div class="row">
                  <div class="col-5">
                     <span class="lead">
                        <h5>OAuth Websites</h5>
                     </span>
                     <br>
                     <div class="btn-group" role="group" aria-label="Basic outlined example">
                        <button type="button"
                           class="btn btn-outline-left btn-md rounded-start-pill btn-check-left hand-cursor"
                           @click="ChangeSettings2('oauth_websites', 1)"
                           :class="{ active: settings['oauth_websites'] == 1 }">Allow</button>
                        <button type="button" class="btn btn-outline-center btn-md btn-check-center hand-cursor"
                           @click="ChangeSettings2('oauth_websites', 0)"
                           :class="{ active: settings['oauth_websites'] == 0 }">Off</button>
                        <button type="button"
                           class="btn btn-outline-right btn-md rounded-end-pill btn-check-right hand-cursor"
                           @click="ChangeSettings2('oauth_websites', 2)"
                           :class="{ active: settings['oauth_websites'] == 2 }">Block</button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>


export default {

   components: {

   },

   data() {
      return {
         headers: [
            { text: "Domain", value: "domain" },
            { text: "Action", value: "action" },
         ],

         settings: [],
         common_cloud_storage: [],
      };

   },

   mounted() {
      this.init();
   },

   methods: {

      init() {
         this.getAccountSettings()
      },

      async getAccountSettings() {
         this.$axios.get("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/get-account-settings")
            .then((response) => {
               this.settings = response.data.settings
               //console.log(this.settings)
            })
            .catch((error) => {
               //console.log(error)
               this.$toast.error(error.response.data.message)
            })

         this.$axios.get("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/get-account-common-cloud-storage")
            .then((response) => {
               this.common_cloud_storage = response.data.common_cloud_storage
               console.log(this.common_cloud_storage)
               console.log(response.data.common_cloud_storage)
            })
            .catch(() => { //error
               //console.log(error)
               //this.$toast.error(error.response.data.message)
            })
      },

      validateEmail(email) {
         return String(email)
            .toLowerCase()
            .match(
               /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
      },

      async AddOrRemoveStorageFromAccount(index) {
         try {

            let payload = {}


            let resp = null

            if (this.common_cloud_storage[index].ww_id.Int64 == 0) {

               payload = {
                  "domain": this.common_cloud_storage[index].website,
                  "id": this.common_cloud_storage[index].ww_id.Int64,
               }

               resp = await this.$axios.post("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/add-storage-to-account", payload)

               if (resp.data.success != null && resp.data.success == false) {
                  this.$toast.error(resp.data.message)
               } else {
                  this.$toast.success(resp.data.message)
                  this.common_cloud_storage[index].ww_id.Int64 = resp.data.allowed_website.id
               }

            } else {

               if (this.common_cloud_storage[index].ww_id.Int64 > 0 && this.common_cloud_storage[index].allow_upload.Bool) {
                  // resp = await this.$axios.delete("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/remove-storage/" + this.common_cloud_storage[index].ww_id.Int64, payload)
                  // this.common_cloud_storage[index].ww_id.Int64 = 0

                  // if (resp.data.success != null && resp.data.success == false) {
                  //    this.$toast.error(resp.data.message)
                  // } else {
                  //    this.$toast.success(resp.data.message)
                  // }

                  payload = {
                     "domain": this.common_cloud_storage[index].website,
                     "id": this.common_cloud_storage[index].ww_id.Int64,
                     "allow_upload": 0
                  }

                  resp = await this.$axios.patch("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/update-account-storage/" + this.common_cloud_storage[index].ww_id.Int64, payload)
                  this.common_cloud_storage[index].ww_id.Int64 = 0

                  if (resp.data.success != null && resp.data.success == false) {
                     this.$toast.error(resp.data.message)
                  } else {
                     this.$toast.success(resp.data.message)
                  }
               } else if (this.common_cloud_storage[index].ww_id.Int64 > 0 && !this.common_cloud_storage[index].allow_upload.Bool) {

                  payload = {
                     "domain": this.common_cloud_storage[index].website,
                     "id": this.common_cloud_storage[index].ww_id.Int64,
                     "allow_upload": 1
                  }

                  resp = await this.$axios.patch("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/update-account-storage/" + this.common_cloud_storage[index].ww_id.Int64, payload)
                  this.common_cloud_storage[index].ww_id.Int64 = 0

                  if (resp.data.success != null && resp.data.success == false) {
                     this.$toast.error(resp.data.message)
                  } else {
                     this.$toast.success(resp.data.message)
                  }
               }
            }

            this.getAccountSettings()


         } catch (error) {
            console.log(error)
            this.$toast.error("An error has occured.")
            // this.$toast.error(error.response.data.message)
         }
      },

      async ChangeSettings(column_name) {

         const columnNameCurrentValue = this.settings[column_name];

         if (column_name == "alert_email") {
            this.settings[column_name] = columnNameCurrentValue
         } else {
            this.settings[column_name] = columnNameCurrentValue == 0 ? 1 : 0;
         }

         let payload = {
            "settings_column": column_name,
            "settings_value": this.settings[column_name]
         }

         //update-account-setting
         const resp = await this.$axios.patch("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/update-account-setting", payload)


         if (resp.data.success != null && resp.data.success == false) {
            this.$toast.error(resp.data.message)
         } else {
            this.$toast.success(resp.data.message)
         }
      },

      async ChangeSettings2(column_name, value) {

         console.log(column_name)

         const columnNameCurrentValue = this.settings[column_name];

         this.settings[column_name] = value


         if (columnNameCurrentValue == value) return;

         let payload = {
            "settings_column": column_name,
            "settings_value": this.settings[column_name]
         }

         //update-account-setting
         const resp = await this.$axios.patch("extension-configuration/" + this.$store.state.auth.organisation_uuid + "/update-account-setting", payload)

         if (resp.data.success != null && resp.data.success == false) {
            this.$toast.error(resp.data.message)
         } else {
            this.$toast.success(resp.data.message)
         }

         console.log("Column Name: ", column_name)
         console.log("Old Value: ", columnNameCurrentValue, " - New Value: ", this.settings[column_name]);
      }
   }

}

</script>

<style scoped>
.card {
   border: none;
}

.label-padding-bottom {
   padding-bottom: 0.3em;
}

.card-title {
   font-style: normal;
   font-weight: 400;
   font-size: 20px;
   color: #435666;
}

.form-check-input:checked {
   background-color: rgba(25, 135, 84, 1.0);
   border-color: rgba(25, 135, 84, 1.0);
}

.form-custom-check-input {
   opacity: 0.7;
   width: 5em !important;
}

.form-custom-check-size {
   min-height: calc(0.8em + 1rem + 1.5px);
   padding: 0.5rem 1rem;
   font-size: 0.8em;
   border-radius: 1rem;
}

.form-control-max-width {
   max-width: 25rem;
}

.inputbox-padding {
   padding-left: 5rem;
}

.table {
   border: 0px 0px 1px 0px;
   font-size: 15px
}

/*design for right button of btn group */
.btn-outline-right {
   color: #191919;
   background-color: transparent;
   background-image: none;
   border-color: grey
}

.btn-outline-right:hover {
   color: whitesmoke;
   font-weight: bold;
   background-color: #191919;
   border-color: #191919
}

.btn-outline-right:focus,
.btn-outline-right.focus {
   box-shadow: 0 0 0 .2rem rgba(119, 204, 204, 0.5)
}

.btn-outline-right.disabled,
.btn-outline-right:disabled {
   color: #191919;
   background-color: transparent
}

.btn-outline-right:not(:disabled):not(.disabled):active,
.btn-outline-right:not(:disabled):not(.disabled).active,
.show>.btn-outline-right.dropdown-toggle {
   color: whitesmoke;
   background-color: #191919;
   font-weight: bold;
   border-color: #191919
}

.btn-outline-right:not(:disabled):not(.disabled):active:focus,
.btn-outline-right:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-right.dropdown-toggle:focus {
   box-shadow: 0 0 0 .2rem rgba(119, 204, 204, 0.5)
}

/* --end-- */

/*design for center button of btn group */
.btn-outline-center {
   color: #a3c0d1;
   background-color: transparent;
   background-image: none;
   border-color: grey
}

.btn-outline-center:hover {
   color: whitesmoke;
   background-color: #B2B2B2;
   font-weight: bold;
   border-color: #B2B2B2;
}

.btn-outline-center:focus,
.btn-outline-center.focus {
   box-shadow: 0 0 0 .2rem rgba(119, 204, 204, 0.5)
}

.btn-outline-center.disabled,
.btn-outline-center:disabled {
   color: #B2B2B2;
   background-color: transparent
}

.btn-outline-center:not(:disabled):not(.disabled):active,
.btn-outline-center:not(:disabled):not(.disabled).active,
.show>.btn-outline-center.dropdown-toggle {
   color: whitesmoke;
   background-color: #B2B2B2;
   font-weight: bold;
   border-color: #B2B2B2
}

.btn-outline-center:not(:disabled):not(.disabled):active:focus,
.btn-outline-center:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-center.dropdown-toggle:focus {
   box-shadow: 0 0 0 .2rem rgba(119, 204, 204, 0.5)
}

/* --end-- */


/*design for left button of btn group */
.btn-outline-left {
   color: rgba(25, 135, 84, 1.0);
   background-color: transparent;
   background-image: none;
   border-color: grey
}

.btn-outline-left:hover {
   color: whitesmoke;
   background-color: rgba(25, 135, 84, 1.0);
   font-weight: bold;
   border-color: rgba(25, 135, 84, 1.0);
}

.btn-outline-left:focus,
.btn-outline-left.focus {
   box-shadow: 0 0 0 .2rem rgba(119, 204, 204, 0.5)
}

.btn-outline-left.disabled,
.btn-outline-left:disabled {
   color: rgba(25, 135, 84, 1.0);
   background-color: transparent
}

.btn-outline-left:not(:disabled):not(.disabled):active,
.btn-outline-left:not(:disabled):not(.disabled).active,
.show>.btn-outline-left.dropdown-toggle {
   color: whitesmoke;
   background-color: rgba(25, 135, 84, 1.0);
   font-weight: bold;
   border-color: rgba(25, 135, 84, 1.0)
}

.btn-outline-left:not(:disabled):not(.disabled):active:focus,
.btn-outline-left:not(:disabled):not(.disabled).active:focus,
.show>.btn-outline-left.dropdown-toggle:focus {
   box-shadow: 0 0 0 .2rem rgba(119, 204, 204, 0.5)
}


.hand-cursor {
   cursor: pointer;
}

/* --end-- */
</style>